export default __webpack_public_path__ + "static/media/user.6b4069ab.jpg";